import type { LoadableType } from '@confluence/loadable';
import { LoadableActivatable, ActivationTriggerType } from '@confluence/loadable';
import { SSR_PARTIAL_COMPONENT } from '@confluence/ssr-utilities/entry-points/ssrPartialSuccess.ts';
import type { LoomCrossFlowPopupComponentProps } from './LoomCrossFlowPopupComponent.tsx';
import type { LoomCrossJoinPopupComponentProps } from './LoomCrossJoinPopupComponent.tsx';

export const LoomCrossFlowPopupLoader: LoadableType<LoomCrossFlowPopupComponentProps> =
	LoadableActivatable({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-LoomCrossFlowPopupComponent" */ './LoomCrossFlowPopupComponent.tsx'
				)
			).LoomCrossFlowPopupComponent,
		triggers: [
			{
				type: ActivationTriggerType.HOVER,
			},
		],
		ssrSuccessCheckName: SSR_PARTIAL_COMPONENT.LoomButton,
	});

export const LoomCrossJoinPopupLoader: LoadableType<LoomCrossJoinPopupComponentProps> =
	LoadableActivatable({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-LoomCrossJoinPopupComponent" */ './LoomCrossJoinPopupComponent.tsx'
				)
			).LoomCrossJoinPopupComponent,
		triggers: [
			{
				type: ActivationTriggerType.HOVER,
			},
		],
		ssrSuccessCheckName: SSR_PARTIAL_COMPONENT.LoomButton,
	});
